/**
 * @generated SignedSource<<e6e259bacd44bc66f93db2d95d74e5f2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OnboardingCriteriaScreenQuery$variables = Record<PropertyKey, never>;
export type OnboardingCriteriaScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OnboardingCriteriaView_query">;
};
export type OnboardingCriteriaScreenQuery = {
  response: OnboardingCriteriaScreenQuery$data;
  variables: OnboardingCriteriaScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "SEQUENCE_ASC"
    ]
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingCriteriaScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OnboardingCriteriaView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OnboardingCriteriaScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMetricSystem",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "onboardedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "age",
                "storageKey": null
              },
              (v0/*:: as any*/)
            ],
            "storageKey": null
          },
          (v1/*:: as any*/),
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Criterion",
            "kind": "LinkedField",
            "name": "criterion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntRange",
                "kind": "LinkedField",
                "name": "ageRange",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntRangeBound",
                    "kind": "LinkedField",
                    "name": "start",
                    "plural": false,
                    "selections": (v2/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntRangeBound",
                    "kind": "LinkedField",
                    "name": "end",
                    "plural": false,
                    "selections": (v2/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isRecentlyActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isLocationDealbreaker",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isVerified",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxDistanceInKm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxDistanceInMi",
                "storageKey": null
              },
              (v1/*:: as any*/),
              (v0/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "GENDER_BY_GENDER_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "GenderCriterionConnection",
            "kind": "LinkedField",
            "name": "genderCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GenderCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "genderId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "genderCriteria(orderBy:[\"GENDER_BY_GENDER_ID__SEQUENCE_ASC\"])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "RelationshipTypeCriterionConnection",
            "kind": "LinkedField",
            "name": "relationshipTypeCriteria",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RelationshipTypeCriterion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relationshipTypeId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "relationshipTypeCriteria(orderBy:[\"RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC\"])"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "GenderConnection",
        "kind": "LinkedField",
        "name": "genders",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Gender",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOther",
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v1/*:: as any*/),
              (v0/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "genders(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "RelationshipTypeConnection",
        "kind": "LinkedField",
        "name": "relationshipTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RelationshipType",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v1/*:: as any*/),
              (v0/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "relationshipTypes(orderBy:[\"SEQUENCE_ASC\"])"
      }
    ]
  },
  "params": {
    "cacheID": "f59da271d05da1db97f76960c5c2a202",
    "id": null,
    "metadata": {},
    "name": "OnboardingCriteriaScreenQuery",
    "operationKind": "query",
    "text": "query OnboardingCriteriaScreenQuery {\n  ...OnboardingCriteriaView_query\n}\n\nfragment GendersMultiSelectInput_query on Query {\n  genders(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment MaxDistanceSliderInput_query on Query {\n  currentUser {\n    isMetricSystem\n    id\n  }\n}\n\nfragment OnboardingCriteriaView_query on Query {\n  currentUser {\n    isMetricSystem\n    onboardedAt\n    profile {\n      age\n      id\n    }\n    rowId\n    id\n  }\n  ...GendersMultiSelectInput_query\n  ...MaxDistanceSliderInput_query\n  ...RelationshipTypesMultiSelectInput_query\n  ...useCriteria_query\n  ...useGenderCriteria_query\n  ...useRelationshipTypeCriteria_query\n}\n\nfragment RelationshipTypesMultiSelectInput_query on Query {\n  relationshipTypes(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment useCriteria_query on Query {\n  currentUser {\n    criterion {\n      ageRange {\n        start {\n          value\n        }\n        end {\n          value\n        }\n      }\n      isRecentlyActive\n      isLocationDealbreaker\n      isVerified\n      maxDistanceInKm\n      maxDistanceInMi\n      rowId\n      id\n    }\n    id\n  }\n}\n\nfragment useGenderCriteria_query on Query {\n  currentUser {\n    genderCriteria(orderBy: [GENDER_BY_GENDER_ID__SEQUENCE_ASC]) {\n      nodes {\n        genderId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment useRelationshipTypeCriteria_query on Query {\n  currentUser {\n    relationshipTypeCriteria(orderBy: [RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC]) {\n      nodes {\n        relationshipTypeId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "23438d8255dad0e1bb5de864051e5f41";

export default node;
